import { useCurrentProjectStore } from '@/lib/current-project';
import { useAuthStore } from '@/stores/authStore';

/**
 * The id remembered views, column choices, page sizes and list return links are kept under (the
 * `{scopeId}` part of a ui-prefs key): the current project, or the user outside a project. Undefined while signed out.
 */
export function usePrefScope(): string | undefined {
  const projectId = useCurrentProjectStore((s) => s.project?.id);
  const userId = useAuthStore((s) => s.user?.id);
  return projectId ?? userId ?? undefined;
}
